import { FC, useContext } from "react"
import { QESButton } from "@app/shared/qes-standards/Button";
import { ProjectPerspective } from "@app/projects/enumerators";
import { timeDistanceCalculatorTypeDisplayMap } from "@app/projects/timeDistanceCalculatorTypeDisplayMap";
import { getTopAndBottomRunConfigurations, getZipTimeString } from "@app/projects/zip-projects/utility";
import { ZipProjectContext } from "@app/projects/zip-projects/ZipProjectContext";

export const ZipProjectPerspectiveNav: FC = () => {
  const projectContext = useContext(ZipProjectContext);
  const { state } = projectContext;

  const { topConfig, bottomConfig } = getTopAndBottomRunConfigurations(state.runConfiguration, state.compareToRunConfiguration, state.isCompareMode, state.isDualMembershipMode);

  return (
    <div className="tabs-style-2">
      <div className="d-flex justify-content-between align-items-center w-100">
        <ul className="nav nav-tabs" role="menu">
          <>
            <li role="none">
              <QESButton
                qesType="none"
                className={`nav-link text-dark fw-normal ${state.perspective === ProjectPerspective.ByZipCode ? "active disabled" : ""}`}
                qesTestId="zip-project-submodule-nav__tab--zip-code"
                onClick={() => projectContext.onChangePerspectiveToZipCode()}
                aria-disabled={state.perspective === ProjectPerspective.ByZipCode}
                role="menuitem"
              >
                By Zip Code
              </QESButton>
            </li>
            <li>
              <QESButton
                qesType="none"
                className={`nav-link text-dark fw-normal ${state.perspective === ProjectPerspective.ByZipClass ? "active disabled" : ""}`}
                qesTestId="zip-project-submodule-nav__tab--zip-class"
                onClick={() => projectContext.onChangePerspectiveToZipClass()}
                aria-disabled={state.perspective === ProjectPerspective.ByZipClass}
                role="menuitem"
              >
                By Classification
              </QESButton>
            </li>
          </>
        </ul>
        {state.runConfiguration?.timeDistanceCalculatorType
          && (
            <div className="d-flex flex-column text-end">
              <p className="mb-2">{state.isCompareMode && getZipTimeString(topConfig)} Distance Method: <b>{timeDistanceCalculatorTypeDisplayMap[(topConfig || state.runConfiguration)?.timeDistanceCalculatorType]}</b></p>
              {state.isCompareMode && <p className="mb-2">{getZipTimeString(bottomConfig)} Distance Method: <b>{timeDistanceCalculatorTypeDisplayMap[(bottomConfig)?.timeDistanceCalculatorType]}</b></p>}
            </div>
          )}
      </div>
    </div>
  )
}